import { IMsalContext } from '@azure/msal-react';

export const isReportAccessForbidden = (accounts: IMsalContext['accounts']) =>
  !(accounts.length > 0 && accounts[0].idTokenClaims?.roles?.includes('customer_support_reports_user'));
